var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "collection-carousel" },
    [
      _c("io-lazy-load", [
        _c(
          "div",
          { staticClass: "carousel__nav" },
          [
            _vm.$mq !== "mobile"
              ? _c("icon-button", {
                  staticClass: "carousel__nav__prev",
                  attrs: {
                    label: "Previous Slide",
                    icon: "chevron-left-big",
                    size: "64px",
                  },
                  on: { click: _vm.slidePrev },
                })
              : _vm._e(),
            _vm.$mq !== "mobile"
              ? _c("icon-button", {
                  staticClass: "carousel__nav__next",
                  attrs: {
                    label: "Next Slide",
                    icon: "chevron-left-big",
                    size: "64px",
                  },
                  on: { click: _vm.slideNext },
                })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "featured-collection__slider" },
          [
            _c(
              "carousel",
              {
                ref: "carousel",
                attrs: {
                  infinite: true,
                  "slides-to-show": ["mobile", "tablet"].includes(_vm.$mq)
                    ? 2
                    : 3,
                  "center-mode": true,
                },
              },
              [_vm._t("default")],
              2
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }